import React, { createContext, useContext } from "react";
import type { SceneBehaviorCatalog } from "../display-editor/layout-types";
const Context = createContext<SceneBehaviorCatalog | undefined>(undefined);
export const SceneObjectTypesProvider = ({
  catalog,
  children,
}: {
  catalog: SceneBehaviorCatalog | undefined;
  children: React.ReactNode;
}) => <Context.Provider value={catalog}>{children}</Context.Provider>;
export const useSceneObjectTypes = () => useContext(Context);
